import random from 'helpers/random';

angular.module('gym.components').directive('timeSequenceCondition', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/sequences/timeSequenceCondition.html.slim'),
    replace: true,
    scope: {
      sequence: '=',
      step: '=',
      isTask: '=',
      isPortal: '=',
      isMobileApp: '=',
      isMembership: '=',
      isWorkout: '=',
      isStyle: '=',
      isNote: '=',
      isProspectStatus: '=',
      isFloatingFollowable: '=',
      index: '='
    },
    controller: ["$scope", function($scope) {
      var base, base1, base2, checkHours, conditionIndex, conditions, getTimeUnits, minValue;
      $scope.id = random();
      conditions = $scope.step.sequence_conditions_attributes;
      conditionIndex = _.findIndex(conditions, function(condition) {
        return condition.type === 'TimeSequenceCondition';
      });
      $scope.condition = $scope.step.sequence_conditions_attributes[conditionIndex];
      $scope.minValue = minValue = function() {
        if ($scope.isFloatingFollowable) {
          return 1;
        } else {
          return 0;
        }
      };
      if ($scope.condition) {
        (base = $scope.condition).time_since_previous_step || (base.time_since_previous_step = minValue());
        (base1 = $scope.condition).time_since_previous_step_unit || (base1.time_since_previous_step_unit = 'days');
        (base2 = $scope.condition).immediate || (base2.immediate = false);
      }
      $scope.isFirst = function() {
        return $scope.index === 1;
      };
      $scope.getAction = function() {
        if ($scope.isTask || $scope.isMembership || $scope.isWorkout || $scope.isStyle || $scope.isNote) {
          return 'add';
        }
        if ($scope.isPortal || $scope.isMobileApp || $scope.isProspectStatus) {
          return 'change';
        }
        return 'send';
      };
      getTimeUnits = function() {
        return $scope.timeUnits = $scope.isFloatingFollowable && $scope.isFirst() ? ['days'] : ['days', 'hours'];
      };
      $scope.$watch('index', function() {
        return getTimeUnits();
      });
      checkHours = function() {
        if (!$scope.condition.immediate && $scope.condition.time_since_previous_step_unit === 'hours') {
          return $scope.condition.allowed_hours = [];
        }
      };
      $scope.onImmediateChanged = function() {
        $scope.condition.time_since_previous_step = 0;
        return checkHours();
      };
      $scope.onTimeUnitChange = function() {
        return checkHours();
      };
      return $scope.isTimeInvalid = function() {
        var ref;
        return ((ref = $scope.sequence.errors) != null ? ref['sequence_steps.sequence_conditions.time_since_previous_step'] : void 0) && !$scope.condition.immediate && ($scope.condition.time_since_previous_step < minValue() || (!$scope.condition.time_since_previous_step && $scope.condition.time_since_previous_step !== 0));
      };
    }]
  };
});
